import { CLIENT_ID } from './authentication-service-constants.js';
import { request } from './request.js';
function requestRefreshToken(options) {
    const { clientId, endpoint, headers, parameters } = options;
    const requestParameters = {
        [CLIENT_ID]: clientId,
        ...parameters,
    };
    return request(endpoint, requestParameters, headers);
}
function revokeRefreshToken(options) {
    const { clientId, endpoint, headers, parameters } = options;
    const requestParameters = {
        [CLIENT_ID]: clientId,
        ...parameters,
    };
    return request(endpoint, requestParameters, headers);
}
export { requestRefreshToken, revokeRefreshToken, };
//# sourceMappingURL=request-refresh-token.js.map